/*
 * @Author: yaoyuting
 * @Date: 2019-08-28 21:56:10
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-04-01 16:51:31
 * @Descripttion:
 */
import Vue from 'vue';
import App from './App.vue';
import router from './router';
// import store from './store';
import '@/assets/reset.css';
// import '@/views/pc/common.less'
// import '@/canvas.js'
import i18n from '@/i18n/i18n.js';
import echarts from 'echarts';

import ElementUI from 'element-ui';
import { goPAGE } from './utils/utils';
import 'element-ui/lib/theme-chalk/index.css';
// import '@/assets/iconfont/iconfont.css';
// import '@/assets/iconfont/iconfont.js';
// import "./assets/font";

// import plugin from './utils/Bus';
import axios from 'axios';
// import 'wowjs/css/libs/animate.css';
// import VueScrollReveal from 'vue-scroll-reveal';
import { Notify, Icon, Popup } from 'vant';


Vue.prototype.$http = axios;
// Vue.use(plugin);

const classify = goPAGE();

Vue.use(ElementUI);
Vue.prototype.$echarts = echarts;

// Vue.use(VueScrollReveal, {
//   duration: 2000,
//   scale: 1,
//   distance: '200px',
//   reset: true,
//   mobile: false,
//   useDelay: 'always',
//   origin: 'bottom',
//   easing: 'linear',

// });

Vue.config.productionTip = false;
// import VueAnimateNumber from 'vue-animate-number'
// Vue.use(VueAnimateNumber)
if (goPAGE() == 'pc') {
  router.push({ path: '/pc/Index' });
} else {
  router.push({ path: '/m/Index' });
}

Vue.use(Popup);
Vue.use(Icon);
// 全局注册
Vue.use(Notify);

new Vue({
  router,
  // store,
  i18n,
  render: h => h(App),
}).$mount('#app');

router.beforeEach((to, from, next) => {
  if (to.fullPath.indexOf(classify) == -1) {
    next(`/${classify}`);
  }
  // chrome
  document.body.scrollTop = 0;
  // firefox
  document.documentElement.scrollTop = 0;
  // safari
  window.pageYOffset = 0;
  next();
});
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});
